import React from 'react';

export const FORM_ERROR = 'Your form contains the following errors:';
export const MEDICAL_PLAN_ERROR = 'You must pick a medical plan.';
export const MEDICAL_PLAN_COVERAGE_ERROR = 'You must pick a coverage level for your medical plan.';
export const DENTAL_PLAN_ERROR = 'You must pick a dental plan.';
export const DENTAL_COVERAGE_ERROR = 'You must pick a coverage level for your dental plan.';
export const HIRE_DATE_ERROR = 'You must specify your hired date.';
export const PRIMARY_RETIREMENT_ERROR = 'You must specify your primary retirement benefit option.';
export const ELIGIBLE_PAY_EMPTY_ERROR = 'You must enter your eligible pay.';
export const ELIGIBLE_PAY_NUMERIC_ERROR = 'Salary must contain a numeric value.';

export const DESIGNATED_FACULTY_ERROR = 'You must specify your designated faculty eligibility.';

export const makeGenericErrorMessage = error => {
  // doing it this way to have time and url at the front of the object
  error = {
    time: new Date().toISOString(),
    ...error
  };
  const email = 'infohelp@ucop.edu';
  const subject = 'UCNET Total Compensation Estimator Error report'
  const body = `
  ErrorInfo:
  ${JSON.stringify(error)}
  `;

  const emailString = `mailto:${email}?subject=${subject}&body=${body}`;
  return (
      <>Something went wrong on our end. If the problem persists please try refreshing the page. If this doesn't work then please contact us at <a href={emailString}>{email}</a>.</>
  );
};
